<template>
  <div class="user-info-wrapper">
    <div class="user-info-container flex justify-space-between">
      <div class="user-info flex align-center">
        <div class="avatar" v-if="false">
          <img src="https://placehold.co/100x100" alt="" />
        </div>
        <div class="details">
          <div class="title">Self Performance Review - 2024</div>
          <div class="user-details"><b>{{ fullName }}</b></div>
        </div>
      </div>
      <div class="progress-container" v-if="false">
        
        <div class="progress-bar" :style="{width: progresswidth, backgroundImage: progressBackground}"></div>
        <div class="text">
          <span>1/10</span>
          <span class="publish-text">Publish Review</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserInfo',
  computed: {
    candidate() {
      return this.$store.getters.candidate
    },

    assessment() {
      return this.$store.getters.assessment
    },

    fullName() {
      if (this.candidate && this.candidate.firstName && this.candidate.lastName) {
        return this.candidate.firstName + ' ' + this.candidate.lastName
      }
      return 'Undefined Candidate'
    },

    progresswidth() {
      return 'calc(100% - 10px)'
    },
    
    progressBackground () {
      return 'linear-gradient(90deg, rgba(72,239,109,1) 70%, rgba(255,255,255,0) 100%)'
    }
  }
}
</script>

<style lang="scss">
  @import "~vars";
  .user-info-wrapper {
    background: white;
    .user-info-container {
      width: 100%;
      max-width: 1240px;
      box-sizing: border-box;
      margin: 0 auto;
      padding: $-grid-gutter;
      padding-left: 0;
      .user-info {
        gap: 20px;
        .avatar {
          max-width: 60px;
          max-height: 60px;
          img {
            width: 100%;
            border-radius: 100%;
          }
        }
        .details {
          .title {
            font-size: 24px;
            font-weight: 700;
          }
          .user-details {
            font-size: 16px;
            padding-top: 5px;
          }
        }
      }
      .progress-container {
        position: relative;
        width: 200px;
        height: 40px;
        background-color: #f0f0f0;
        border-radius: 8px;
        padding: 5px;
        .progress-bar {
          position: absolute;
          top: 5px;
          left: 5px;
          height: 80%;
          background: linear-gradient(90deg, rgba(72,239,109,1) 70%, rgba(255,255,255,0) 100%);
          border-radius: 8px;
          width: calc(40% - 10px);
          transition: width 0.5s ease;
        }
        .text {
          position: relative;
          z-index: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 100%;
          padding: 0 10px;
          color: #000;
          font-weight: bold;
          .publish-text {
            margin-left: 10px;
            color: #bbb;
            font-weight: normal;
          }
        }
      } 
    }
  }
</style>